import React, { useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { userContext } from "../../../Contexts/userContext";
import { MoonLoader } from "react-spinners";
import { Switch } from "@mui/material";
import ReportCard from "../../../Components/Molecules/Cards/ReportCard/ReportCard";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ClassIcon from "@mui/icons-material/Class";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import useDelete from "../../../Hooks/useDelete";
import { classesURL } from "../../../Hooks/URL";
import StudentCard from "../../../Components/Molecules/Cards/StudentCard/StudentCard";

function ClassReportDetails({
  Class,
  students,
  loading,
  reportsVisible,
  setReportsVisible,
  setGoEdit,
  report,
  report_id,
}) {
  const [goDelete, setGoDelete] = useState(false);
  const { deleteState, loading: deleteLoading } = useDelete(
    `${classesURL}/${Class?.id}/class-feedbacks/${report_id}`,
    goDelete,
    `classes/${Class?.id}`
  );

  const monthsList = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {/* Class Header */}
      <div className="contentSection">
        <div className="courseHeader">
          <div className="titleIcon">
            <AssessmentIcon />
          </div>
          <div className="courseBasicInfo">
            <h1 className="courseName">
              {monthsList.find((month) => month.id === report?.month)?.name}{" "}
              Report
            </h1>
          </div>
          <div className="courseStats">
            <div
              className="statItem clickable"
              onClick={() => {
                const element = document.getElementById("students");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <PersonIcon className="statIcon" />
              <span className="statLabel">Students</span>
              <span className="statValue">{students?.length || 0}</span>
            </div>
            <div
              className="statItem"
              onClick={() => {
                const element = document.getElementById("reports-settings");
                element?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              <VisibilityIcon className="statIcon" />
              <span className="statValue">
                {reportsVisible ? "Visible" : "Hidden"}
              </span>
            </div>
            <DeleteForm
              setGo={setGoDelete}
              title={"Are you sure to delete this report?"}
            />
          </div>
        </div>

        <div className="infoGrid">
          <div className="infoItem">
            <div className="infoLabel">
              <VisibilityIcon className="infoIcon" />
              Reports Visibility
            </div>
            <div
              className="infoValue"
              style={{ display: "flex", alignItems: "center", gap: "12px" }}
            >
              <Switch
                checked={reportsVisible}
                onChange={() => {
                  setGoEdit(true);
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#012369",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#012369",
                    },
                  },
                }}
              />
              <span>
                {reportsVisible
                  ? "Reports are visible to parents"
                  : "Reports are hidden from parents"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Students Reports Section */}
      <div className="contentSection" id="students">
        <div className="lessonsHeader">
          <h2 className="sectionTitle">Student Reports</h2>
        </div>

        {students?.length ? (
          <div className="studentsGridClass">
            {students?.map((student) => (
              <StudentCard
                Class={Class}
                feedback={true}
                feedbackId={report_id}
                key={student?.id}
                student={student}
                isTerminated={Class?.isTerminated}
              />
            ))}
          </div>
        ) : (
          <div className="emptyState">
            <PersonIcon className="emptyIcon" />
            <h3>No Students Enrolled</h3>
            <p>
              There are no students enrolled in this class to generate reports
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ClassReportDetails;
